import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Frequency } from '../models/frequency';

@Injectable({
  providedIn: 'root'
})
export class FrequencyService {

  constructor(
    private db: AngularFirestore,

  ) { }

  selectByEvent(event_id: any) {
    return this.db.collection<Frequency>('sbccv_inout', ref => ref
      .where("event_id", "==", event_id)
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc')).snapshotChanges();
  }


}
